export const DEBUG = true;

// JQUERY PREFIX
export const JQUERY_ELEMENT_TAG = '#';
export const JQUERY_CLASS_TAG = '.';

// ENGINE PREFIX
export const NODE_TYPE_LAYER = 'Layer';
export const GROUP_PREFIX = 'grp_';
export const BG_PREFIX = 'bg_';
export const RECT_PREFIX = 'rect_';
export const TEXT_PREFIX = 'text_';
export const TEXT_RECTANGLE_PREFIX = 'rec_';
export const SNAPSHOT_PREFIX = 'snp_';
export const SNAPSHOT_CONTAINER_PREFIX = 'snp_c_';
export const SNAPSHOT_STAGE_NAME = 'stageHidden';

// ENGINE MODES
export const MODE_ENGINE_IMAGES = 'mode_engine_images';
export const MODE_ENGINE_BACKGROUND = 'mode_engine_background';
export const MODE_ENGINE_PREVIEW_SNAPSHOTS = 'mode_engine_preview_snapshots';
export const MODE_ENGINE_PREVIEW_STAGE = 'mode_engine_preview_stage';

// BUS PREFIX
export const EVENT_LOAD_COMPLETE = 'LoadComplete';
export const EVENT_SNAPSHOT_STAGE_COMPLETE = 'snapshotStageComplete';
export const EVENT_SNAPSHOTS_RENDER_COMPLETE = 'snapshotsRenderComplete';
export const EVENT_SNAPSHOT_RENDER_COMPLETE = 'snapshotRenderComplete';
export const EVENT_SNAPSHOT_BACKGROUNDS_RENDER_COMPLETE = 'snapshotBackgroundsRenderComplete';
export const EVENT_SNAPSHOT_IMAGES_RENDER_COMPLETE = 'snapshotImagesRenderComplete';
export const DATATRANSFER_NAME = 'name';
export const DATATRANSFER_PATH = 'path';
export const DATATRANSFER_TEXT = 'user-text';
export const DATATRANSFER_COUNT = 'count';

// TEXT PANEL
export const TEXT_PANEL = '#text_panel';
export const TEXT_BTN_SAVE = '#btn_text_save';
export const TEXT_BTN_CANCEL = '#btn_text_cancel';
export const TEXT_TXT = '#txt_text';
export const TEXT_HIDDEN = '#txt_hidden';

// TREE PREFIX
export const TREE_COVER_PAGE = 'cvr';
export const BACK_COVER_PAGE = 'bck';

// GENERIC INPUTS
export const INPUT_TOKEN = '#token';
export const INPUT_EVENT_TOKEN = '#event_token';

// SPINNER
export const SPINNER = '#spinner';

// PAGES / SNAPSHOT PREVIEW
export const PAGES_PREVIEW = '#pages_preview';
export const PAGES_PREVIEW_MAIN_CONTAINER = '#pages_preview_main_container';
export const SNAPSHOTS_CLASS_SELECTED = 'snapshots_selected';
export const SNAPSHOTS_CLASS_UNSELECTED = 'snapshots_unselected';
export const PAGE_ID_PREFIX = 'pgt';
// HEADER
export const HEADER_ID = '#header';
export const HEADER_CLASS_PAGE_SELECTED = '.header_page_selected';
export const HEADER_CLASS_PAGE_CELLS_SELECTED = '.header_page_cells_selected';

export const HEADER_CLASS_PAGE_UNSELECTED = '.header_page_unselected';
export const HEADER_CLASS_PAGE_CELLS_UNSELECTED = '.header_page_cells_unselected';

// FOOTER
export const FOOTER_ID = '#footer';
export const FOOTER_FILTERS = '#footer_filters';
export const FOOTER_PICTURES_CONTAINER = '#footer_pictures_container';
export const FOOTER_PICTURES_OVERFLOW = '#footer_pictures_overflow';
export const FOOTER_BTN_ADD_IMAGES = '#btn_footer_add_images';
export const FOOTER_BTN_ARROW_LEFT = '#btn_footer_pictures_arrow_left';
export const FOOTER_BTN_ARROW_RIGHT = '#btn_footer_pictures_arrow_right';
export const FOOTER_PICTURE_PANEL = '#footer_pictures_panel';

export const FOOTER_CHECKBOX_FILTER_ALL = '#checkbox_footer_filter_all';
export const FOOTER_CHECKBOX_FILTER_EXCLUDE = '#checkbox_footer_filter_exclude';
export const FOOTER_CHECKBOX_FILTER_INCLUDE = '#checkbox_footer_filter_include';

export const FOOTER_FILTER_CLASS_CHECKBOX_SELECTED = '.footer_filter_checkbox_selected';
export const FOOTER_FILTER_CLASS_CHECKBOX_UNSELECTED = '.footer_filter_checkbox_unselected';

export const FOOTER_IMAGES_PANEL = '#footer_images_panel';
export const FOOTER_BACKGROUND_PANEL = '#footer_background_panel';

export const FOOTER_OPTIONS_PICTURES = '#footer_options_pictures';
export const FOOTER_OPTIONS_BACKGROUNDS = '#footer_options_backgrounds';

export const FOOTER_OPTIONS_CLASS_SELECTED = '.footer_options_selected';
export const FOOTER_OPTIONS_CLASS_UNSELECTED = '.footer_options_unselected';

export const FOOTER_CHECKBOX_SORTING_EXIF = '#checkbox_footer_sorting_exif';
export const FOOTER_CHECKBOX_SORTING_UPLOAD = '#checkbox_footer_sorting_upload';
export const FOOTER_SORTING_CLASS_CHECKBOX_SELECTED = '.footer_sorting_checkbox_selected';
export const FOOTER_SORTING_CLASS_CHECKBOX_UNSELECTED = '.footer_sorting_checkbox_unselected';

// ENGINE
export const ENGINE_ID = '#engine';
export const ENGINE_STAGE = '#stage';
export const ENGINE_STAGE_MAIN = '#stage_main';
export const ENGINE_BTN_LEFT_WRAPPER = '#stage_arrow_left_wrapper';
export const ENGINE_BTN_RIGHT_WRPPER = '#stage_arrow_right_wrapper';
export const ENGINE_BTN_ARROW_LEFT = '#btn_stage_arrow_left';
export const ENGINE_BTN_ARROW_RIGHT = '#btn_stage_arrow_right';
export const ENGINE_POPUP = '#stage_popup';
export const ENGINE_STAGE_WRAPPER = '#stage_wrapper';
export const ENGINE_STAGE_PANEL_FOOTER = '#stage_panel_footer';
export const ENGINE_PANEL_FOOTER_NEXT = '#stage_panel_footer_next';
export const ENGINE_PANEL_FOOTER_PREV = '#stage_panel_footer_prev';

// AJAX
export const HTTP_METHOD_GET = 'GET';
export const HTTP_METHOD_POST = 'POST';
export const CONTENT_TYPE = 'application/x-www-form-urlencoded; charset=UTF-8';
export const DATA_TYPE_JSON = 'json';
export const DATA_TYPE_TEXT = 'text';
export const ERROR_YOU_NOT_MASTER = 'ERROR_YOU_NOT_MASTER';
export const TOKEN_IS_MISSING = 'TOKEN_IS_MISSING';

// COVER
export const COVER_SCALE = 1.048;
export const COVER_SCALE_X = 1.015;

export const IMAGE_TEXT_LIMIT = 21;
export const MAX_PAGES_LIMIT = 72;

// STAGES
export const DRAG_HELPER = 'dragHelper';
export const SELECTED_RECTANGLE = 'selectedRectangle';

export const DRAG_HELPER_IMAGE = 'dragHelperImage';
export const DRAG_HELPER_WIDTH = 120;
export const DRAG_HELPER_HEIGHT = 120;
export const DRAG_HELPER_BORDER = '#8eb541';
export const OVERLAY_RECTANGLE = 'overlayRectangle';
export const OVERLAY_RECTANGLE_COLOR = '#000';
export const OVERLAY_RECTANGLE_OPACITY = 0.45;
export const SELECTED_RECTANGLE_BORDER = 4;
export const GRAYED_RECTANGLE = 'grayedRectangle';
export const GRAYED_RECTANGLE_COLOR = '#eaeaea';
export const DROP_AREA = 'dropArea';
export const DROP_AREA_ACTIVE_COLOR = '#8eb541';
export const DROP_AREA_DISABLED_COLOR = '#dedede';
export const DROP_AREA_ACTIVE_TEXT = '+ הוסיפו תמונה לעמוד';
export const DROP_AREA_DISABLED_TEXT = 'לא ניתן להוסיף יותר מ-6 תמונות לעמוד אבל אפשר להחליף';
export const DROP_AREA_HEIGHT = 60;
export const DROP_AREA_HEIGHT_ACTIVE = 70;
export const DROP_AREA_TXT_FILL_COLOR = '3e3e3e';
export const MAX_IMAGES_IN_REGION = 6;
export const FONT_FAMILY = 'Spoiler, SpoilerEN, sans-serif';

// LAYOUT HASHES THAT NEEDS TO MOVE EDIT BUTTON

export const LAYOUT_HASH_RIGHT_BUTTONS = ['0062562544520160160445180160160', '0062562544520160160'];

// ENUMS
export enum STAGE_LAYERS {
    Base = 1,
    Background = 2,
    Frame = 3,
    Images = 4,
    Stickers = 5,
    Texts = 6,
}
export enum REGION_SIDE {
    Right = 1,
    Left = 2,
}
export enum HISTORY_ACTION_TYPE {
    Page = 1,
    Tree = 2,
}
